export const ApiUrl = "https://trenquelauquen.gov.ar/pp2023_api/";

export const Headers = {
    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8',
    'Apikey':'c5LTA6WPbMwHhEabYu77nN9cn4VcMj'
  };